import React, { useState, useEffect, useCallback } from 'react';
import { Search, Tag, X, Filter, SortDesc } from 'lucide-react';

/**
 * Search and filter bar for contracts
 */
const ContractSearch = ({
    onSearch,
    searchValue = ''
}) => {
    const [localSearch, setLocalSearch] = useState(searchValue);

    // Debounce search
    useEffect(() => {
        const timer = setTimeout(() => {
            onSearch(localSearch);
        }, 300);
        return () => clearTimeout(timer);
    }, [localSearch, onSearch]);

    const handleClearSearch = () => {
        setLocalSearch('');
        onSearch('');
    };

    return (
        <div className="flex flex-col sm:flex-row gap-3 mb-6">
            {/* Search Input */}
            <div className="relative flex-1">
                <Search
                    size={18}
                    className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
                />
                <input
                    type="text"
                    value={localSearch}
                    onChange={(e) => setLocalSearch(e.target.value)}
                    placeholder="Search contracts..."
                    className="w-full pl-10 pr-10 py-2.5 rounded-xl border border-[#3c3c3c] bg-[#252526] text-white placeholder-gray-400 focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                />
                {localSearch && (
                    <button
                        onClick={handleClearSearch}
                        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 hover:bg-[#3c3c3c] rounded-full transition-colors"
                    >
                        <X size={16} className="text-gray-400" />
                    </button>
                )}
            </div>
        </div>
    );
};

export default ContractSearch;
